import { ParentEvent } from "@g.frame/core";
import { Vector2, Vector3 } from "three";
import Stage from "../Stage";
import LeavesQuizModule from "./modules/LeavesQuizModule";
export default class LeavesLevel extends Stage {
    constructor(modulesProcessor, uiManager, environment, levelsManager) {
        super(modulesProcessor, uiManager, environment);
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.levelsManager = levelsManager;
        this.currentStep = 0;
        this.leavesQuizModule = new LeavesQuizModule(this.modulesProcessor, this.uiManager);
        this.addObject(this.leavesQuizModule);
        this.controlsPosition = {
            camera: new Vector3(5.076, 1.8, 2.141),
            // cameraVR: new Vector3(3.494, 1.8, 1.589),
            target: new Vector3(5.03, 1.8, 2.122)
        };
        this.uiObject.position.set(2.525, 1.275, 1.125);
        this.uiObject.rotation.set(0, 1.2271846, 0);
        // // @ts-ignore
        // window.nextStep = (step) => {
        //     this.nextStep(step);
        //     // @ts-ignore
        //     return this.uiManager.text
        // }
    }
    init() {
        this.initAssets();
        this.leavesQuizModule.init();
    }
    startLevel() {
        this.off('start_level');
        this.leavesQuizModule.reset();
        this.showStartMessage();
        this.enableFinishEvent();
    }
    enableFinishEvent() {
        this.leavesQuizModule.once('done', () => {
            let allLevelsFinished = true;
            let nextHash = '#Lobby';
            for (const levelHash in this.levelsManager.levelList) {
                const level = this.levelsManager.levelList[levelHash];
                if (this !== level && levelHash !== '#Lobby') {
                    if (!level.completed) {
                        nextHash = levelHash;
                        allLevelsFinished = false;
                        break;
                    }
                }
            }
            this.showFinalMessage('Crop Leaf Identification', allLevelsFinished);
            this.on('restart_level', () => {
                this.off('restart_level');
                this.off('next_level_button');
                this.leavesQuizModule.reset();
                this.leavesQuizModule.enableModule(true);
                this.nextStep(1);
                this.enableFinishEvent();
            });
            this.on('next_level_button', () => {
                this.off('restart_level');
                this.off('next_level_button');
                this.fire('next_level', new ParentEvent('next_level', { level: nextHash }));
                this.resetStage();
            });
        });
    }
    showStartMessage() {
        if (this.completed) {
            this.fire('start_level', new ParentEvent('start_level'));
            this.leavesQuizModule.enableModule(true);
            this.nextStep(1);
        }
        else {
            const pop = {
                header: 'Crop Leaf Identification',
                body: 'In this level you are going to identify crop leaves and pair them with the appropriate labels. Click the continue button to get started.',
            };
            this.uiManager.on('first_button_click', () => {
                this.uiManager.off('first_button_click');
                this.fire('start_level', new ParentEvent('start_level'));
                this.leavesQuizModule.enableModule(true);
                this.nextStep(1);
            });
            this.uiManager.showWelcomePopUp(pop);
        }
    }
    nextStep(step) {
        if (typeof step !== 'undefined')
            this.currentStep = step;
        switch (this.currentStep) {
            case (1): {
                this.uiManager.hidePopUpScreen();
                this.uiManager.hideText().then(() => {
                    this.uiManager.setText({
                        background: this.uiManager.getTextBackground({
                            size: new Vector2(.558, .16),
                            headerHeight: .06,
                        }),
                        elements: [
                            {
                                object: this.uiManager.getTextHeader({
                                    text: 'Crop Leaf Identification',
                                    window: {
                                        size: new Vector2(.510, .028),
                                        scale: 1,
                                        pxScale: 1
                                    }
                                }),
                                margin: 0.016 + 0.014
                            },
                            {
                                object: this.uiManager.getTextBody({
                                    text: 'Drag and drop the the appropriate label to the empty slots once you found a match.',
                                    window: {
                                        size: new Vector2(.510, .052),
                                        scale: 1,
                                        pxScale: 2.125
                                    }
                                }),
                                margin: 0.084 + 0.026
                            }
                        ]
                    });
                });
                break;
            }
        }
    }
    resetStage() {
        this.off('restart_level');
        this.off('next_level_button');
        this.uiManager.off('first_button_click');
        this.leavesQuizModule.reset();
    }
    initAssets() {
    }
}
